import React from 'react';
import { siteConfig } from '../siteData';
import '../App.css';

function Footer() {
  return (
    <footer className="footer-minimal">
      <div className="footer-minimal-top">
        <div className="footer-minimal-container">
          <div className="footer-minimal-logo">
            <img src={siteConfig.logo.src} alt={siteConfig.logo.alt} />
          </div>
          <nav className="footer-minimal-nav">
            {siteConfig.navigation.map((item, index) => (
              <a key={index} href={item.link}>{item.label}</a>
            ))}
          </nav>
          <div className="footer-minimal-social">
            {siteConfig.footer.socialMedia.map((social, index) => (
              <a
                key={index}
                href={social.url}
                className="footer-social-icon"
                target="_blank"
                rel="noopener noreferrer"
                title={social.platform}
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="footer-minimal-bottom">
        <p>{siteConfig.footer.copyright}</p>
      </div>
    </footer>
  );
}

export default Footer;
